// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__BbCwV","emails":"CreateEditClinics_emails__31oez","emailTagLabel":"CreateEditClinics_emailTagLabel__2dDom"};